import DatePickerViewModelBase from '@/ViewModels/Controls/DatePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper';
import ResourceManager from '@/Management/ResourceManager';
import {IDatePickerViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

export default class DatePickerViewModel extends DatePickerViewModelBase {

    public constructor(params: IDatePickerViewModelConstructorParameter) {
        super(params);
    }

    /**
     * @override
     * @inheritdoc 
     * @param date
     */
    protected parseToDotNetString(date: string): string {
        return date ? DateHelper.toDotNetDateString(new Date(date)) : '';
    }

    protected parseToHtmlDateTimeString(date: string | Date): string {
        return date ? DateHelper.extractDateFromDate(date) : '';
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return language.datePattern;
        });
    }
}

ComponentManager.setViewModel('DatePickerViewModel', DatePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');